import { render, staticRenderFns } from "./PackageExtrasModal.vue?vue&type=template&id=65663e4d&scoped=true"
import script from "./PackageExtrasModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PackageExtrasModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PackageExtrasModal.vue?vue&type=style&index=0&id=65663e4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65663e4d",
  null
  
)

export default component.exports